export const customToolbarSettings = {
  items: ['FontName', 'FontSize', 'Bold', 'Italic', 'Alignments', 'Indent', 'Outdent', 'Formats', '-', 'OrderedList', 'UnorderedList', 'CreateLink', 'CreateTable', 'FontColor', 'BackgroundColor', 'Undo', 'Redo'],
};
